<form novalidate [formGroup]="formGroup">
  <div *ngFor="let form of forms; let first = first; let index = index">
    <ng-container *ngIf="'input' === form.type && !form.hide">
      <div *ngIf="form.showLabel" class="u-marginBottom-8">
        <ng-container i18n="@@settingsView.inputLabel">{form.label, select,
          other {{{ form.label }}}
        }</ng-container>
      </div>
      <mat-form-field class="mat-form-field-width-100">
        <input
          matInput
          #input
          [formControlName]="form.updateKey"
          [type]="form.data?.inputType"
          [placeholder]="form.disable ? '' : form.data?.placeholder"
          [maxLength]="form.data?.limit || 524288"
        />
        <mat-hint *ngIf="form.data?.limit && !form.disable" align="end">
          {{ input.value.length }} / {{ form.data?.limit }}
        </mat-hint>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="'select' === form.type && !form.hide">
      <mat-form-field>
        <mat-select
          [placeholder]="form.data?.placeholder"
          (click)="form.callback ? form.callback(form) : {}"
          [formControlName]="form.updateKey"
        >
          <mat-option
            *ngFor="let option of form.data?.options"
            [value]="option.value"
          >
            <span i18n="@@settingsView.selectOption">{option.text, select,
              other {{{ option.text }}}
            }</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="'checkbox' === form.type && !form.hide">
      <div
        *ngIf="form.showLabel"
        [ngClass]="{ 'u-marginTop-24': !first }"
        class="u-paddingBottom-24"
      >
        <ng-container
          i18n="@@settingsView.checkboxGroupLabel"
          >{form.label, select, other {{{ form.label }}}
        }</ng-container>
      </div>
      <mat-checkbox
        [checked]="form.model"
        [formControlName]="form.updateKey"
        (change)="form.callback ? form.callback(formGroup.value) : {}"
      >
        <span
          i18n="@@settingsView.checkboxOption"
          >{form.data?.placeholder, select, other {{{ form.data?.placeholder }}}
        }</span>
      </mat-checkbox>
    </ng-container>
    <ng-container *ngIf="'advancedCheckbox' === form.type && !form.hide">
      <div
        *ngIf="form.showLabel"
        [ngClass]="{ 'u-marginTop-24': !first }"
        class="u-paddingBottom-24"
      >
        <ng-container
          i18n="@@settingsView.advancedCheckboxGroupLabel"
          >{form.label, select, other {{{ form.label }}}
        }</ng-container>
      </div>
      <div class="u-marginBottom-8">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          class="u-marginBottom-16"
        >
          <div fxFlex="0 0 20px" class="u-marginRight-8">
            <mat-checkbox
              [checked]="form.model"
              [formControlName]="form.updateKey"
              (change)="form.callback ? form.callback(formGroup.value) : {}"
              class="u-marginRight-8 mat-checkbox--longText"
            >
            </mat-checkbox>
          </div>
          <div
            fxFlex="0 0 calc(100% - 28px)"
            fxLayout="row"
            fxLayoutAlign="start center"
            class="u-marginRight-8"
          >
            <ng-container
              i18n="@@settingsView.advancedCheckboxOption"
              >{form.data?.placeholder, select,
                other {{{ form.data?.placeholder }}}

            }</ng-container>
          </div>
        </div>
        <app-form-template-body
          [forms]="form.subForms"
          (formChange)="subFormGroupChange($event.update, $event.formGroup)"
          class="u-display-block u-paddingLeft-24"
        >
        </app-form-template-body>
      </div>
    </ng-container>
    <div
      *ngIf="'avatar' === form.type && !form.hide"
      [ngStyle]="{ width: '120px' }"
    >
      <div *ngIf="form.showLabel" class="u-marginBottom-8">
        <ng-container i18n="@@settingsView.avatarLabel">{form.label, select,
          other {{{ form.label }}}
        }</ng-container>
      </div>
      <div
        *ngIf="form.model"
        fxLayout="row"
        fxLayoutAlign="center center"
        class="u-marginBottom-16"
      >
        <app-avatar [imageUrl]="form.model" [size]="96" class="u-display-block">
        </app-avatar>
      </div>
      <div class="u-width-100">
        <app-upload-file
          [text]="'Upload Image'"
          [imageUrl]="form.model"
          [raised]="true"
          [color]="'primary'"
          [documentType]="form.data?.documentType"
          (imageChanged)="imageChange(form, $event)"
          class="u-display-block"
        >
        </app-upload-file>
      </div>
    </div>
    <ng-container *ngIf="'chips' === form.type && !form.hide">
      <div>
        <mat-form-field class="mat-form-field-width-100">
          <mat-chip-grid #chipList>
            <mat-chip-row
              *ngFor="let chip of form.model"
              color="primary"
              selected="true"
              (removed)="removeChip(form.model, chip)"
            >
              <div fxLayout="row" fxLayoutAlign="start center">
                <div>{{ chip }}</div>
                <ng-container *ngIf="!form.disable">
                  <i matChipRemove class="material-icons"> cancel </i>
                </ng-container>
              </div>
            </mat-chip-row>
            <input
              matInput
              [placeholder]="form.data?.placeholder || ''"
              [disabled]="form.disable"
              [ngStyle]="{ width: '100%' }"
              [matChipInputFor]="chipList"
              [matChipInputAddOnBlur]="true"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="
                addChipToList(form.model, form.updateKey, $event)
              "
            />
          </mat-chip-grid>
        </mat-form-field>
        <ng-container
          *ngIf="formGroup.get(form.updateKey).hasError('isInList')"
        >
          <mat-error i18n="@@settingsView.chipEmailExist.error"
            >Email is already in the list.
          </mat-error>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="'number' === form.type && !form.hide">
      <mat-form-field color="primary" appearance="fill">
        <mat-label
          i18n="@@settingsView.inputNumberLabel"
          >{form.data.label, select, other {{{ form.data.label }}}
        }</mat-label>
        <input
          matInput
          type="number"
          [min]="form.data.min"
          [formControlName]="form.updateKey"
        />
        <span *ngIf="form.data.suffix" matSuffix>
          <ng-container
            i18n="@@settingsView.timeSuffix"
            >{form.data.suffix, select, other {{{ form.data.suffix }}}
          }</ng-container>
        </span>
        <mat-error
          *ngIf="!!formGroup.get(form.updateKey).hasError('min')"
          i18n="@@settingsView.minValue.error"
        >
          Minimum value: {{ formGroup.get(form.updateKey).getError('min').min }}
        </mat-error>
      </mat-form-field>
    </ng-container>
  </div>
</form>
<ng-container
  *ngIf="
    !formGroup.hasError('length') &&
    !formGroup.hasError('confirmEmpty') &&
    formGroup.hasError('noMatch')
  "
>
  <mat-error i18n="@@settingsView.passwordMatch.error"
    >Passwords do not match.
  </mat-error>
</ng-container>
<ng-container *ngIf="formGroup.hasError('length')">
  <mat-error i18n="@@settingsView.passwordLength.error"
    >Your password must be at least 8 characters long.
  </mat-error>
</ng-container>
<ng-container
  *ngIf="!formGroup.hasError('length') && formGroup.hasError('confirmEmpty')"
>
  <mat-error i18n="@@settingsView.passwordConfirm.error"
    >Must confirm new password.
  </mat-error>
</ng-container>
